/* eslint no-param-reassign: "off", no-console: "off" */

const storageStore = {
  state: {
    softwareFiles: [],
    documents: [],
    documentsSearching: false,
    documentsSearchResults: []
  },
  mutations: {
    setSoftwareFiles(state, payload) {
      state.softwareFiles = payload;
    },
    setDocumentationFiles(state, payload) {
      state.documents = payload;
    },
    setDocumentSearchResults(state, payload) {
      state.documentsSearchResults = payload;
      state.documentsSearching = false;
    },
    clearDocumentSearchResults(state) {
      state.documentsSearchResults = [];
    }
  },
  actions: {
    async fetchStorageFiles({ commit }, container) {
      try {
        // call to API to fetch list of blobs
        const res = await fetch(`/v2/storage/blob/list?container=${container}`);
        if (!res.ok) throw new Error('The request to retreive blob files failed.');
        const blobs = await res.json();
        switch (container) {
          case 'software-downloads':
            commit('setSoftwareFiles', blobs);
            break;
          case 'documents':
            commit('setDocumentationFiles', blobs);
            break;
          default:
            break;
        }
        return false;
      } catch (err) {
        console.error(err);
        return false;
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async downloadStorageFile({}, file) {
      try {
        if (!file.absolutePath) throw new Error('Invalid arguments.');

        const payload = {
          container: file.container,
          filePath: file.absolutePath,
          view: file.view || false
        }
        console.log('[downloadStorageFile] file: ', file);
        const res = await fetch('/v2/storage/blob', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        // ensure success
        if (!res.ok) throw new Error('Unable to acquire file URL.');
        // acquire the file URL from the response content
        return await res.text();
      } catch (ex) {
        console.error(ex);
        return null;
      }
    },
    async searchDocuments({ state, commit }, payload) {
      try {
        state.documentsSearching = true;
        const searchResult = await fetch(`/v2/search?searchTerm=${payload}&take=999`);
        const results = await searchResult.json()
        commit('setDocumentSearchResults', results.documentResults);
      } catch (ex) {
        console.error(ex);
      }
    }
  }
}
export default storageStore;
